import React from 'react'
import styled from 'styled-components'
import {withForm, Errors, SimpleRadiobox, SimpleCheckbox, TextInput, Field} from 'startlibs/lib/form'
import {getPlanType, normalizeSubscription, stripeIntervalToInterval, toPrice} from '../lib/index'
import {
  CheckoutPage, CouponFeedback, OrderSummaryWrapper,
  PlanBillingOptionContainer,
  PlanHeader,
  PlanPrice,
  PlanPriceDetail,
  PlanRadio, PromoCodeContainer,
  SubscriptionPlan, SubscriptionPlanList, TextInputWithButton,
  ContentSection, CurrentPlanLabel, InfoBox
} from './CheckoutComponents'
import {STORAGE_PLAN_TYPE_DETAILS} from '../user/Billing'
import {withToggles, fetchConnect, withRouteTo} from 'startlibs/lib/hocs'
import {Button, Icon, Loading} from 'startlibs/lib/components'
import {setNotifications, userSubscriptionSuccess} from '../reducers/index'
import URLSearchParams from 'url-search-params'
import {getFetcher} from 'startlibs'
import {CheckoutSignupDialog} from './CheckoutSignupDialog'
import {CreditCardCheckout} from './CreditCardCheckout'
import {StorageCheckoutSuccess} from './CheckoutSuccess'
import {Timer} from 'report-components/src/components/timer'
import {buildValidation} from '../lib/validation'
import {ice} from 'icepath'

const StorageVolumeWrapper = styled(ContentSection)`
`
const WorkstationsWrapper = styled(ContentSection)`
`
const TextInputWithTextBox = styled.div`
  >div {
    margin-bottom: 0;
    >div {
      border-radius: 5px !important;
      :before {
        border-radius: 5px !important;
      }
      input {
        width: auto !important;
        flex-grow: 1 !important;
        :focus {
          box-shadow: none !important;
        }
      }
      input ~ span {
        border-top-right-radius: 5px;
        border-bottom-right-radius: 5px;
        margin-left: -4px;
        min-width: 126px;
        position: relative;
        justify-content: center;
        white-space: nowrap;
      }
    }
  }
  .increment-buttons {
    position: absolute;
    left: -5.75rem;
    top: 50%;
    transform: translateY(-50%);
    a span {
      padding: 0.5rem;
      background-color: rgba(0,0,0,0.1);
      margin-left: 0.5rem;
      border-radius: 100px;
      width: 2rem;
      line-height: 1rem;
      display: inline-block;
      text-align: center;
      font-size: 17px;
      user-select: none;
      :hover {
        background-color: rgba(0,0,0,0.15);
      }
      :active {
        background-color: rgba(0,0,0,0.2);
      }
    }
  }
`

const STORAGE_PLAN_TYPE_HEADER = {
  'STORAGE_STANDARD': 'Standard',
  'STORAGE_PRO': 'Pro'
}

const PlanRadioComponent = ({form, plan, monthlyCost, isCurrent}) =>
  <PlanRadio form={form}
             className="plan-box selectable"
             path="planType"
             discontinuedPlan={plan.discontinued}
             fieldValue={plan}>
    {plan.amount === 0 ? <PlanPrice>Free</PlanPrice> :
     <PlanPrice>Starting at ${toPrice(plan.amount)} USD / {plan.interval}</PlanPrice>}
    {monthlyCost && <PlanPriceDetail>You save ${toPrice((monthlyCost * 12) - plan.amount)} USD</PlanPriceDetail>}
    {isCurrent && <CurrentPlanLabel>Current</CurrentPlanLabel>}
  </PlanRadio>

const SubscriptionPlansCard = ({form, plans, planType, currentPlanId, currentStatus, children}) => {
  const isCardSelected = plans.find(plan => plan === form.properties.planType)
  const discontinuedPlan = !plans.find(_ => !_.discontinued)
  return <SubscriptionPlan
    onClick={() => !isCardSelected && form.connector.setValue('planType', plans.find(_ => _.interval === form.properties.planType.interval))}
    selected={!!isCardSelected}
    discontinuedPlan={discontinuedPlan}
  >
    <PlanHeader>{STORAGE_PLAN_TYPE_HEADER[planType]} {discontinuedPlan && '(discontinued)'}</PlanHeader>
    {STORAGE_PLAN_TYPE_DETAILS[planType]()}
    <PlanBillingOptionContainer>
      {plans.sort((a, b) => a.amount < b.amount ? 1 : -1).map(plan => <PlanRadioComponent
          plan={plan}
          key={plan.id}
          form={form}
          isCurrent={plan.id === currentPlanId}
          monthlyCost={plan.interval === 'year' && plans.filter(_ => _.interval !== 'year').map(_ => _.amount)[0]}
        />
      )}
    </PlanBillingOptionContainer>
  </SubscriptionPlan>
}

export const getUnvolumedPlanName = (planName) => planName.split('_').slice(0, 2).join('_')
const getPlanVolume = (planName) => planName.split('_')[2]

@fetchConnect(({user}) => ({user}), {userSubscriptionSuccess, setNotifications}, 'stripe')
@withForm()
@withRouteTo
@withToggles('couponLoading', 'checkoutStep')
export class StorageCheckout extends React.PureComponent {

  state = {}

  stripePlans = this.props.stripe.storagePlans.plans
  isUpgradePlan = (new URLSearchParams(this.props.location.search)).get('of') === 'plan'

  vpnCost = {
    year: this.props.stripe.vpnstationPriceYear,
    month: this.props.stripe.vpnstationPrice
  }

  preValidation = buildValidation({
    acceptedTerms: (v) => !v && 'You must read & agree to the License Terms.'
  })


  componentDidMount() {
    const params = new URLSearchParams(this.props.location.search)
    const plan = (params.get('plan') || 'PRO').toUpperCase()
    const interval = 'year'
    this.props.form.connector.setValues((chain) =>
      chain.assign({
        'planType': this.stripePlans.find(_ => _.name.indexOf(`_${plan}_`) > 0 && _.interval === interval),
        'volume': '40',
        'workstationsVPN': 1
      })
    )
    if (this.props.stripe.customer) {
      this.setStripeCustomer(this.props.stripe)
    } else if (this.props.user.id) {
      getFetcher('/api/stripe-customer')
        .then(this.setStripeCustomerAfterMount)
    }
  }

  setStripeCustomerAfterMount = (stripe) => {
    const customer = stripe.customer
    if (!this.isUpgradePlan && customer.subscriptions && customer.subscriptions.data && customer.subscriptions.data.find(_ => _.metadata && _.metadata.type === 'STORAGE')) {
      this.props.routeTo('/billing')
    } else {
      this.setStripeCustomer(stripe)
    }
  }

  setStripeCustomer = (stripe) => {
    const customer = stripe && stripe.customer
    if (customer) {
      const currentCard = customer.sources && customer.sources.data && customer.sources.data[0]
      const currentSubscription = normalizeSubscription(customer.subscriptions && customer.subscriptions.data && customer.subscriptions.data.find(_ => _.metadata && _.metadata.type === 'STORAGE'), currentCard)
      this.setState({
        loadedStripeCustomer: true,
        currentCard,
        currentSubscription
      }, this.fetchProrate)
    } else {
      this.setState({
        loadedStripeCustomer: true
      })
    }
  }

  componentDidUpdate(oldProps) {
    if (
      this.state.currentSubscription &&
      this.getFinalPlan(oldProps.form.properties).id !== this.getFinalPlan(this.props.form.properties).id ||
      oldProps.form.properties.workstationsVPN !== this.props.form.properties.workstationsVPN
    ) {
      this.fetchProrate()
    }
  }

  confirmCoupon = (e) => {
    e.preventDefault()
    const {coupon} = this.props.form.properties
    this.props.couponLoading.open()
    getFetcher('/api/coupon-test', {coupon})
      .then((couponDiscount) => {
        if (this.state.currentSubscription && this.state.currentSubscription.id) {
          this.fetchProrate(true, coupon)
        } else if (couponDiscount.valid) {
          this.setState({couponDiscount, coupon, couponError: null})
          this.props.couponLoading.close()
          this.props.form.connector.setValue('coupon', '')
        } else {
          return Promise.reject(couponDiscount)
        }
      })
      .catch(() => {
        if (this.state.currentSubscription && this.state.currentSubscription.id) {
          this.fetchProrate(true, null)
        } else {
          this.setState({coupon, couponDiscount: null, couponError: 'invalid.coupon'})
          this.props.couponLoading.close()
          this.props.form.connector.setValue('coupon', '')
        }
      })
  }

  isCanceled = () => this.state.currentSubscription.status === 'canceled' || this.state.currentSubscription.status === 'canceled_renewal'

  stripePlansIds = this.stripePlans.map(_ => _.id)

  getCurrentPlanId = () => this.state.currentSubscription && (
    this.isCanceled()
    ? ''
    : ice(this.state.currentSubscription)
      .get(['subscriptionItems', 'data'])
      .filter(_ => _.plan)
      .map(_ => _.plan.id)
      .value()
      .find(_ => this.stripePlansIds.indexOf(_) >= 0)
  )
  hasCurrentActivePlan = () => this.state.currentSubscription && this.state.currentSubscription.status === 'active'

  getCurrentVPNs = () =>
    !this.state.currentSubscription
    ? 0
    : ice(this.state.currentSubscription)
      .get(['subscriptionItems', 'data'])
      .filter(_ => _.plan)
      .map(_ => [_.plan.id, _.quantity])
      .value()
      .filter(([planId]) => this.stripePlansIds.indexOf(planId) < 0)
      .reduce((acc, [, quantity]) => acc + quantity, 0)

  isCurrentPlanSelected = () => this.hasCurrentActivePlan() && this.getCurrentPlanId() === this.getFinalPlan().id && this.getCurrentVPNs() === this.props.form.properties.workstationsVPN

  fetchProrate = (checkingCoupon, checkedCoupon) => {
    const currentPlan = this.getCurrentPlanId()
    const finalPlan = this.getFinalPlan(this.props.form.properties)
    const isPro = getUnvolumedPlanName(finalPlan.name) === 'STORAGE_PRO'
    const stripePlanId = finalPlan.id
    if (!this.state.currentSubscription || !this.state.currentSubscription.id || this.isCurrentPlanSelected()) {
      this.props.couponLoading.close()
      return
    }
    if (!checkingCoupon) {
      this.setState({prorate: null, couponError: null})
    }

    const numberOfWorkstationsVPN = isPro ? Number(this.props.form.properties.workstationsVPN) : 0
    const coupon = checkingCoupon ? checkedCoupon : this.state.coupon
    getFetcher('/api/pro-rata', {
      subscriptionId: this.state.currentSubscription.id,
      stripePlanId,
      numberOfWorkstationsVPN,
      ...(coupon ? {coupon} : {})
    }).then(prorate => {
        if (checkingCoupon) {
          this.props.form.connector.setValue('coupon', '')
        }
        const couponError =
          checkingCoupon && !coupon ? 'invalid.coupon' :
          coupon && !prorate.discount ? 'invalid.coupon.plan' :
          prorate.discount ? null :
          this.state.couponError
        this.props.couponLoading.close()
        this.setState({
          prorate,
          coupon,
          couponDiscount: ice.get(prorate, 'discount.coupon'),
          couponError
        })
      })
      .catch(() => {
        this.props.couponLoading.close()
        if (checkingCoupon) {
          this.props.form.connector.setValue('coupon', '')
        }
        this.setState({prorate: null})
      })
  }


  getFinalPlan = (properties = this.props.form.properties) => {
    const selectedPlan = properties.planType || this.stripePlans[0]
    const interval = selectedPlan.interval
    const planType = getUnvolumedPlanName(selectedPlan.name)
    const volume = properties.volume || '40'
    return this.stripePlans.find(_ => _.name === `${planType}_${volume}` && _.interval === interval) || selectedPlan
  }

  login = () => {
    const validated = this.preValidation(this.props.form.properties, {})
    if (validated.errors) {
      return this.props.form.connector.setErrors(validated.errors)
    }
    if (this.props.user.id) {
      this.props.checkoutStep.open(2)
    } else {
      this.props.checkoutStep.open(1)
    }
  }

  isCurrentPlanMonthly = () => {
    const currentPlanId = this.getCurrentPlanId()
    if (currentPlanId) {
      return this.stripePlans.find(_=>_.id === currentPlanId && _.interval === 'month')
    } else {
      return false
    }
  }

  render() {
    if (!this.isUpgradePlan && this.props.user.id && !this.state.loadedStripeCustomer) {
      return <Loading absolute size={40} borderWidth={6}/>
    }

    const {form, checkoutStep, couponLoading, user} = this.props
    const {coupon: appliedCoupon, couponDiscount, prorate, couponError} = this.state
    const selectedPlanType = form.properties.planType || this.stripePlans[0]
    const planNameWithoutVolume = getUnvolumedPlanName(selectedPlanType.name)
    const isCurrentPlanSelected = this.isCurrentPlanSelected()
    const orderPreview = (changePlanButton, finished) => <OrderPreview
      finished={finished}
      form={form}
      vpnCost={this.vpnCost[selectedPlanType.interval]}
      stripePlans={this.stripePlans}
      finalPlan={this.getFinalPlan()}
      confirmCoupon={this.confirmCoupon}
      appliedCoupon={appliedCoupon}
      couponDiscount={couponDiscount}
      couponLoading={couponLoading}
      prorate={prorate}
      couponError={couponError}
      changePlanButton={changePlanButton}
    />

    if (checkoutStep.isOpen === 2) {
      return <CreditCardCheckout
        currentCard={this.state.currentCard}
        orderPreview={orderPreview}
        isStorage
        finalPlan={this.getFinalPlan()}
        prorate={prorate}
        hasCurrentActivePlan={this.hasCurrentActivePlan()}
        coupon={appliedCoupon}
        workstationsVPN={planNameWithoutVolume === 'STORAGE_PRO' ? Number(form.properties.workstationsVPN) : 0}
        form={form}
        isCurrentPlanSelected={isCurrentPlanSelected}
        nextStep={() => checkoutStep.open(3)}
        prevStep={checkoutStep.close}
      />
    }
    if (checkoutStep.isOpen === 3) {
      return <StorageCheckoutSuccess
        planName={getPlanType(getUnvolumedPlanName(this.getFinalPlan().name))}
        orderPreview={orderPreview}
      />
    }

    return <CheckoutPage className="content edit-profile">
      <div className={'profile-header checkout-header'}>
        <h1>{this.hasCurrentActivePlan() && "Update "}Horos Access subscription</h1>
        <Button.a small href='https://info.horosproject.org/horos-cloud-faq' target="_blank">Learn more</Button.a>
      </div>
      <h3>Select your Horos Access plan</h3>
      <PlanTypeSelection
        isCurrentMonthly={this.isCurrentPlanMonthly()}
        form={form}
        currentPlanId={this.getCurrentPlanId()}
        stripePlans={this.stripePlans}
      />
      <StorageVolumeWrapper>
        <div className="heading-text">
          <h3>Cloud Storage Volume</h3>
        </div>
        <div className="card">
          <StorageVolumeSelection
            form={form}
            stripePlans={this.stripePlans}
            selectedPlanType={selectedPlanType}
          />
        </div>
      </StorageVolumeWrapper>
      {
        planNameWithoutVolume === 'STORAGE_PRO' &&
        <WorkstationsWrapper>
          <h3>Number of workstations</h3>
          <div className="card">
            <p>First workstation is free and it
              is <b>${toPrice(this.vpnCost[selectedPlanType.interval])} USD per {selectedPlanType.interval}</b> for
              each
              additional workstation accessing Protected Health Information.</p>
            <NumberOfWorkstationsInput
              form={form}
              vpnCost={this.vpnCost[selectedPlanType.interval]}
              interval={selectedPlanType.interval}
            />
          </div>
        </WorkstationsWrapper>
      }
      {
        isCurrentPlanSelected &&
        <InfoBox>
          <span><strong>The plan and billing period you selected is already active in your current subscription.</strong> If you'd like to change your plan, select another option above and click 'Update subscription'. For changing your credit card details only, click below.</span>
        </InfoBox>
      }
      {orderPreview()}
      <div className="checkbox-list">
        <SimpleCheckbox
          form={form}
          label={<span className="license-terms-agreement">By continuing, you confirm you have read and accept the Horos Cloud <a
            className="link nowrap" href="/license" target="_blank">License Terms</a>.</span>}
          path="acceptedTerms"
          tabIndex={1}
        />
      </div>
      <Errors form={form}/>
      <div className="profile-footer">
        {user.id && <Button onClick={() => window.history.back()}>Cancel</Button>}
        <Button highlight disabled={isCurrentPlanSelected} onClick={this.login}>Next</Button>
        {
          checkoutStep.isOpen === 1 &&
          <CheckoutSignupDialog
            closeDialog={checkoutStep.close}
            form={form}
            setStripCustomer={this.setStripeCustomer}
            nextStep={() => checkoutStep.open(2)}
          />
        }
      </div>
    </CheckoutPage>
  }

}

const PlanTypeSelection = ({form, stripePlans, currentPlanId, isCurrentMonthly}) =>
  <SubscriptionPlanList>
    <SubscriptionPlansCard
      planType="STORAGE_STANDARD"
      form={form}
      currentPlanId={currentPlanId}
      plans={stripePlans.filter(_ => _.name === 'STORAGE_STANDARD_40' && (isCurrentMonthly || _.interval !== 'month'))}
    />
    <SubscriptionPlansCard
      planType="STORAGE_PRO"
      form={form}
      currentPlanId={currentPlanId}
      plans={stripePlans.filter(_ => _.name === 'STORAGE_PRO_40' && (isCurrentMonthly || _.interval !== 'month'))}
    />
  </SubscriptionPlanList>

const StorageVolumeSelection = ({form, stripePlans, selectedPlanType}) =>
  <div>
    <p>Select your {stripeIntervalToInterval(selectedPlanType.interval)} storage package:</p>
    <div className="radio-list">
      {stripePlans
        .filter(_ =>
          _.name.indexOf(getUnvolumedPlanName(selectedPlanType.name)) === 0 &&
          _.interval === selectedPlanType.interval
        )
        .sort(_ => _.amount)
        .map(plan =>
          <SimpleRadiobox
            form={form}
            key={plan.name}
            path="volume"
            fieldValue={getPlanVolume(plan.name)}
            label={`${getPlanVolume(plan.name)} studies/month for $${toPrice(plan.amount)} USD/${plan.interval}`}
          />
        )
      }
    </div>
  </div>

const calculateVPN = (cost, numberOfStations) => cost * (numberOfStations - 1)

const NumberOfWorkstationsInput = ({form, vpnCost, interval}) => {
  const vpnTotalCost = calculateVPN(vpnCost, form.properties.workstationsVPN)
  return <div>
    <TextInputWithTextBox>
      <TextInput
        form={form}
        path="workstationsVPN"
        constraint="#####"
        defaultValue={1}
        maxLength={5}
        textBoxAfter={<div><span className="increment-buttons"><a
          onClick={() => form.connector.setValues((chain) => chain.update('workstationsVPN', (v) => Math.max(1, v - 1)))}><Icon
          icon="minus"/></a>
      <a
        onClick={() => form.connector.setValues((chain) => chain.update('workstationsVPN', (v) => Math.min(99999, v + 1)))}><Icon
        icon="plus"/></a></span>
      <span>{vpnTotalCost === 0 ? 'Free' : `$${toPrice(vpnTotalCost)} USD / ${interval}`}</span></div>}
      />
    </TextInputWithTextBox>
  </div>
}

const getNextCharge = (interval, nextPaymentAttempt, saldo, cost) => {
  const intervals = saldo <= 0 ? -saldo / cost : 0
  const nextChargeDate = nextPaymentAttempt ? new Date(nextPaymentAttempt * 1000) : new Date()
  if (intervals > 0) {
    if (interval === 'yearly') {
      nextChargeDate.setFullYear(nextChargeDate.getFullYear() + Math.ceil(intervals))
    } else {
      nextChargeDate.setMonth(nextChargeDate.getMonth() + Math.ceil(intervals))
    }
  }
  const nextCharge = intervals === 0 ? saldo : cost + (saldo % cost)
  return [nextCharge, nextChargeDate]
}

const OrderPreview = ({form, stripePlans, changePlanButton, couponDiscount, vpnCost, finalPlan, confirmCoupon, appliedCoupon, couponLoading, prorate, couponError, finished}) => {
  const interval = stripeIntervalToInterval(finalPlan.interval)
  const planType = getUnvolumedPlanName(finalPlan.name)
  const planTitle = STORAGE_PLAN_TYPE_HEADER[planType]
  const volume = form.properties.volume
  const workstationsVPN = form.properties.workstationsVPN
  const vpnTotalCost = planType === 'STORAGE_PRO' ? calculateVPN(vpnCost, workstationsVPN) : 0
  const totalCost = vpnTotalCost + finalPlan.amount
  const discount = couponDiscount ? (couponDiscount.percentOff ? (totalCost * couponDiscount.percentOff / 100) : (couponDiscount.amountOff || 0)) : 0
  const hasProrateCredit = prorate && (prorate.lines && prorate.lines.data && prorate.lines.data && prorate.lines.data.filter(_ => _.amount < 0))
  const startingBalance = (prorate && prorate.startingBalance) || 0
  const prorateCredit = hasProrateCredit ? (-hasProrateCredit.reduce((sum, {amount}) => sum + Number(amount), 0) - startingBalance) : 0
  const discountedPrice = totalCost - discount - prorateCredit

  const [nextCharge, nextPaymentDate] = getNextCharge(interval, prorate && prorate.nextPaymentAttempt, discountedPrice, totalCost)

  return <OrderSummaryWrapper>
    <div className="heading-text">
      <h3>Your Order {changePlanButton}</h3>
    </div>
    <div className="card order">
      <div className="order-table">
        <div><span><b>{planTitle} Plan</b> ({interval})</span></div>
        <div>
          <span>{volume} studies/month storage:</span>
          <span className="amount">${toPrice(finalPlan.amount)} USD</span>
        </div>
        {
          planType === 'STORAGE_PRO' &&
          <div>
            <span>{workstationsVPN} workstations access:</span>
            <span className="amount">${toPrice(vpnTotalCost)} USD</span>
          </div>
        }
        <div className="total">
          <span><b>Total</b> ({interval})</span>
          <span className="amount"><b>${toPrice(totalCost)} USD</b></span>
        </div>
        {
          discount > 0 &&
          <div>
            <span>Promo code discount ({couponDiscount.percentOff ? `${couponDiscount.percentOff}%` : `$${toPrice(couponDiscount.amountOf)} USD`}):</span>
            <span className="discount amount">-${toPrice(discount)} USD</span>
          </div>
        }
        {
          prorateCredit > 0 &&
          <div>
            <span>Credit from current subscription:</span>
            <span className="discount amount">-${toPrice(prorateCredit)} USD</span>
          </div>
        }
        {
          discountedPrice !== totalCost &&
          <div>
            <span><b>Your first payment (<Timer language="en" dateFormat="L dd, yyyy" noHours time={nextPaymentDate}/>)</b></span>
            <span className="amount"><b>${toPrice(nextCharge)} USD</b></span>
          </div>
        }
      </div>
      {
        !finished &&
        <PromoCodeContainer>
          <form onSubmit={confirmCoupon}>
            <Field label="Promo Code">
              <TextInputWithButton>
                <div className="input-container">
                  <TextInput form={form} path="coupon" placeholder="Insert your promo code"/>
                </div>
                <Button small isLoading={couponLoading.isOpen} type="submit">Apply</Button>
              </TextInputWithButton>
            </Field>
          </form>
          {
            couponDiscount &&
            <CouponFeedback success>
              <span className="applied-coupon">{appliedCoupon}</span>
              <b>Coupon successfully applied.</b>
              <div>
                {couponDiscount.percentOff ?
                 `${couponDiscount.percentOff}% off on first payment.` :
                 `$${toPrice(couponDiscount.amountOf)} USD off.`
                }
              </div>
            </CouponFeedback>
          }
          {
            couponError &&
            <CouponFeedback error>
              {appliedCoupon && <span className="applied-coupon">{appliedCoupon}</span>}
              {couponError === 'invalid.coupon' && <div>Sorry, the coupon you entered is not valid.</div>}
              {couponError === 'invalid.coupon.plan' &&
              <div>This coupon is valid only for annual plan subscriptions and upgrades.</div>}
            </CouponFeedback>
          }
        </PromoCodeContainer>
      }
      {
        finished &&
        <PromoCodeContainer>
          {(STORAGE_PLAN_TYPE_DETAILS[planType] || (() => 0))()}
        </PromoCodeContainer>
      }
    </div>
  </OrderSummaryWrapper>

}



// WEBPACK FOOTER //
// ./src/javascripts/checkout/StorageCheckout.jsx